import useSWR, { mutate } from 'swr';
import apiClient from '../../utils/axiosConfig';
import { useState, useEffect } from 'react';
import { useQuery } from '../../hook/useQuery';

const fetcher = url => apiClient.get(url).then(res => res.data);

export const useClient = () => {

    const [itemsPerPage, setPerPge] = useState(50)
    const [page, setPage] = useState(1);
    const [queryString, setQueryString] = useState(' ')

    const { filterUrl } = useQuery();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [clients, setClients] = useState([]);
    const [allClients, setAllClients] = useState([]);
    const [total, setTotal] = useState([]);
    const [lastPage, setLastPage] = useState([]);

    const fetchData = async () => {
        const queryString = filterUrl() || '';
        const url = `/client?perPage=${itemsPerPage}&page=${page}&${queryString}`;
        try {
            const response = await apiClient.get(url);
            await mutate(`/client?perPage=${itemsPerPage}&page=${page}&${queryString}`);
            setData(response?.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data || 'An error occurred');
            setData(null);
        }
    };

    useEffect(() => {
        if (data?.data?.clients?.data) {
            setClients([...data?.data?.clients?.data]);
            setTotal(data?.data?.clients?.total);
            setLastPage(data?.data?.clients?.last_page);
        }
    }, [data]);
    const fetchAllData = async () => {
        try {
            const response = await apiClient.get('/client')
            setAllClients(response?.data)
        } catch (error) {

        }
    }
    const createClient = async (newData) => {
        try {
            const response = await apiClient.post('/client', newData);
            mutate(`/client?perPage=${itemsPerPage}&page=${page}`);
            return response.data
        } catch (error) {
            return error.response.data
        }
    };

    const updateClient = async (id, updatedData) => {
        try {
            const response = await apiClient.put(`/client/${id}`, updatedData);
            mutate(`/client?perPage=${itemsPerPage}&page=${page}`);
            return response
        } catch (err) {
            return err.response.data
        }
    };

    const deleteClient = async (id) => {
        try {
            const response = await apiClient.delete(`/client/${id}`);
            mutate(`/client?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };

    const getClientById = async (servicePointId) => {
        const response = await apiClient.get(`/client/${servicePointId}`);
        return response.data;
    };

    const updateStatus = async (id) => {
        try {
            const response = await apiClient.put(`/client/${id}/status`);
            mutate(`/client?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };
    const getAll = async () => {
        try {
            const response = await apiClient.get(`/client`);
            mutate(`/client`);
            return Array.isArray(response?.data?.data?.clients) ? response?.data?.data?.clients : [];
        } catch (err) {
            return err.response.data;
        }
    }
    const handleSaveCabinet = async (clientId, selectedCabinets) => {
        const form = {
            client_id: clientId,
            cabinets: selectedCabinets,
        };
        try {
            const response = await apiClient.put(`client/cabinet/update`, form);
            mutate(`/client?perPage=${itemsPerPage}&page=${page}`);
            return response.data
        } catch (error) {
            return error.response.data
        }
    };

    const getExcelData = async () => {
        try {
            const queryString = filterUrl() || '';
            const url = queryString ? `/client?is_for_excel=1&${queryString}` : `/client?is_for_excel=1`;

            const response = await apiClient.get(url);
            const data = response?.data?.data?.clients;

            const mapServicepoints = (data) => data.map(object => ({
                name: object?.name,
                nickname: object?.nickname,
                email: object?.email,
                wallet: object?.wallet,
                phone: object?.phone,
            }));

            const clients = Array.isArray(data)
                ? mapServicepoints(data)
                : Array.isArray(data?.data)
                    ? mapServicepoints(data.data)
                    : [];

            return clients;

        } catch (err) {
            return err.response?.data || { error: 'An unexpected error occurred' };
        }
    };

    return {
        allClients: Array.isArray(allClients?.data?.clients) ? allClients?.data?.clients : [],
        clients,
        fetchAllData,
        fetchData,
        isLoading: !error && !data,
        isError: error,
        itemsPerPage,
        lastPage,
        currentPage: page,
        total,
        setPage,
        updateStatus,
        createClient,
        updateClient,
        deleteClient,
        getClientById,
        mutate,
        getAll,
        setPerPge,
        handleSaveCabinet,
        getExcelData,
        queryString,
        setQueryString
    };
};
